import { useState } from 'react';
import { usePersistentStorage } from './usePersistentStorage';
import useUser from './useUser';
import { useMount } from '@simplywallst/ui-core';

export function useUserLocale() {
  const { get, set } = usePersistentStorage();
  const { data: user, mutateAsync: mutateUser } = useUser();
  const [userLocale, setUserLocale] = useState(user.preferredLocale ?? 'en');

  const persistentStorageKey = 'userLocale';

  useMount(() => {
    // On mount, if the user profile does not provide a locale, fall back to
    // whatever we happen to have in local storage.
    if (!user.preferredLocale) {
      get(persistentStorageKey).then((locale) => setUserLocale(locale ?? 'en'));
    }
  });

  return [
    userLocale,
    async (value: string) => {
      const setter: Promise<unknown>[] = [set(persistentStorageKey, value)];
      if (user.loggedIn) {
        setter.push(
          mutateUser({
            settings: {
              preferred_locale: value,
            },
          })
        );
      }
      await Promise.all(setter);
      setUserLocale(value);
    },
  ] as const;
}
